
/**
 * 地块绘制工具
 */
import Base from "./Base";
import * as turf from '@turf/turf'
import mapboxgl from "mapbox-gl";
import MapboxDraw from "../../../static/lib/mapbox-gl-draw";
import {TOOL_EDIT_AREA} from "./ToolType";

export default class EditArea extends Base {
  constructor(map,{callBack:callBack=null,errorCallBack:errorCallBack=null,feature={}}={}) {
    super(map,TOOL_EDIT_AREA,{callBack:callBack,errorCallBack:errorCallBack});
    this.feature=feature;
    this.draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {}}
    );
    this.map.addControl(this.draw);
    let ids = this.draw.set({
      type: 'FeatureCollection',
      features: [this.feature]
    });
    this.featureId=ids[0];
  }

  start() {
    super.start();
    this.disableMap();
    this.draw.changeMode(this.draw.modes.DIRECT_SELECT,{featureId:this.featureId});

    this.updateEvent=(e)=>{
      this.update(e)
    };
    this.map.on('draw.update', this.updateEvent);
    this.createEvent=(e)=>{
      let feature=this.draw.get(this.featureId);
      //检测自相交
      let featureSet= turf.kinks(feature);
      if(featureSet.features.length>0){
        this.error("多边形自相交");
      }else {
        this.finish(feature)
      }
    };
    this.map.on('draw.modechange', this.createEvent);
  }

  update(e){
    this.clearPopup();
    let area=turf.area(e.features[0]);
    let center=turf.center(e.features[0]);

    this.popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick:false,
      className:this.popupClassName
    });
    this.popup.setLngLat(center.geometry.coordinates)
      .setText((area*0.0015).toFixed(2)+"亩")
      .addTo(this.map);
  }

  /**
   * 移除长度文字
   */
  clearPopup(){
    if(this.popup){
      this.popup.remove();
      this.popup=null;
      super.clearPopup();
    }
  }
  close() {
    this.enableViewMap();
    this.clear();
    this.clearEvent();
  }

  clear() {
    this.clearPopup();
    this.clearMap();
  }

  clearMap() {
    if(this.draw){
      this.draw.deleteAll();
    }
  }

  clearEvent() {
    super.clearEvent();
    this.map.off('draw.update',this.updateEvent);
    this.map.off('draw.modechange',this.createEvent);
    if(this.draw){
      this.map.removeControl(this.draw);
      this.draw=null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/tool/edit/EditArea.js